import { Component } from '@angular/core';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { CustomerService } from '~core/services';

/**
 * Commponent that will display a form with email that you must complete in order to access the customer overview
 */
@Component({
  selector: 'app-customer-access-email',
  templateUrl: './customer-access-email.component.html'
})
export class CustomerAccessEmailComponent {
  public opened: boolean = true;

  constructor(
    public customerService: CustomerService,
    public buttonsTranslations: ButtonsTranslations,
  ) { }

  /**
   * Toggles the opened class
   */
  close(): void {
    this.opened = false;
  }
}
